import React from 'react';
import { FiAlertCircle, FiArrowLeft, FiHome } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col bg-[#F4FBF8] text-[#17231F]">
      <SEO page="not-found" />
      <Header />

      <main id="main-content" className="flex flex-1 items-center overflow-hidden">
        <section className="relative w-full px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_15%,rgba(20,184,166,0.16),transparent_34%),radial-gradient(circle_at_86%_74%,rgba(217,119,6,0.13),transparent_28%)]" />
          <div className="relative mx-auto max-w-3xl text-center">
            <div className="mx-auto mb-7 grid h-16 w-16 place-items-center rounded-2xl border border-amber-500/20 bg-white text-[#D97706] shadow-xl shadow-emerald-950/5">
              <FiAlertCircle className="h-7 w-7" aria-hidden="true" />
            </div>
            <p className="text-[clamp(5.5rem,18vw,10rem)] font-black leading-none tracking-[-0.08em] text-[#0B2F2A]">404</p>
            <div className="mx-auto mt-7 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#D97706] via-[#14B8A6] to-[#166534]" />
            <h1 className="mt-6 text-3xl font-semibold tracking-tight text-[#0B2F2A] sm:text-5xl">Page not found</h1>
            <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-[#2D4A43] sm:text-lg">
              The page you’re looking for may have moved, been removed, or the link may be incorrect.
            </p>
            <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
              <a href="/" className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#0B2F2A] px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#14564d] focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:ring-offset-2">
                <FiHome className="h-4 w-4" aria-hidden="true" />
                Back to home
              </a>
              <button type="button" onClick={() => window.history.back()} className="inline-flex items-center justify-center gap-2 rounded-xl border border-emerald-900/15 bg-white px-5 py-3 text-sm font-bold text-[#1C362F] transition-colors hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:ring-offset-2">
                <FiArrowLeft className="h-4 w-4" aria-hidden="true" />
                Go back
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
